import * as Yup from 'yup';

import { CartItem } from 'store/api/cart/types';
import { phoneNumber, validateZipCode } from 'utils/validation';

import { FormValues } from './types';

export const mobileStepTitles = ['Products', 'Shipment', 'Package'];
export const stepTitles = [
  'List of product',
  'Customer Shipment Info',
  'Package',
];

export const initialValues: FormValues = {
  zip: '',
  city: '',
  phone: '',
  email: '',
  state: '',
  address: '',
  products: [],
  lastName: '',
  firstName: '',
  recipientId: '',
  shippingPrice: '',
  isNewCustomer: true,
  isFreeShipping: false,
};

const getRecipientValidation = (isNewCustomer = true) =>
  Yup.string().when('isNewCustomer', {
    is: isNewCustomer,
    then: (schema) => schema.required(),
    otherwise: (schema) => schema.notRequired(),
  });

export const getValidationSchemas = (availableProducts?: CartItem[]) => {
  const availableMap = new Map(
    (availableProducts ?? []).map((item) => [item.id, item.quantity])
  );

  return [
    Yup.object().shape({
      products: Yup.array()
        .of(
          Yup.object().shape({
            id: Yup.number().required(),
            quantity: Yup.number()
              .required('Quantity is a required field')
              .min(1, 'Quantity must be greater than or equal to 1')
              .test(
                'max-quantity',
                'Quantity exceeds available stock',
                function (value) {
                  const { id } = this.parent;
                  const available = availableMap.get(id);
                  if (available === undefined || value === undefined) {
                    return true;
                  }
                  return value <= available;
                }
              ),
          })
        )
        .min(1, 'At least one product is required'),
    }),
    Yup.object().shape({
      zip: validateZipCode(),
      isNewCustomer: Yup.boolean(),
      city: Yup.string().required(),
      state: Yup.string().required(),
      address: Yup.string().required(),
      lastName: getRecipientValidation(),
      firstName: getRecipientValidation(),
      email: Yup.string().email().required(),
      phone: phoneNumber('phone').required(),
      recipientId: getRecipientValidation(false),
    }),
    Yup.object().shape({
      isFreeShipping: Yup.boolean(),
      shippingPrice: Yup.number().required('Price is a required field').min(1),
    }),
  ];
};
